import React, { useEffect, useMemo, Suspense } from 'react';
import { Edges, Text, Billboard } from '@react-three/drei';
import Rack from './Rack';
import Bin from './Bin';

const isStorageLocation = (name) => ["Bin", "Grid"].includes((name || "").trim());

const Zone = ({ zone, onBinClick, selectedBin, selectedRack, setSelectedRack, setLegendData, selectedEntity, color, opacity, setBinCounts }) => {
  const { children = [], xco, yco, zco, width, length,en_name,entity_name } = zone;
  // Label rendered in world space at the physical FRONT edge of each zone
  const labelLift = 2; // lift above floor; extra for pallets
  const labelMarginZ = 2; // keep slightly inside the front edge
  const frontBillboardPos = useMemo(() => [0, labelLift, (length / 2) - labelMarginZ], [length, labelLift]);
  useEffect(() => {
    setLegendData((prevState) => {
      const alreadyExists = prevState.some(item => item.name === zone.en_name);
      if (alreadyExists) return prevState;
      return [...prevState, { name: zone.en_name, color: "orange" }];
    });
  }, [zone.en_name, setLegendData])

  const hasSelection = selectedEntity?.entity != null;
  const isCurrentZoneSelected = selectedEntity?.entity?.id === zone.id;

  return (
    <>
      <group position={[xco, yco, zco]}>
        <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, 0, 0]} receiveShadow>
          <planeGeometry args={[width, length]} />
          <meshStandardMaterial transparent opacity={0} />
          <Edges color={color} threshold={1} scale={1.001} linewidth={2} />
        </mesh>

        <Suspense fallback={null}>
          <Billboard position={frontBillboardPos}>
            <Text
              fontSize={4}
              fontWeight={900}
              color={color}
              anchorX="center"
              anchorY="middle"
              billboard
            >
              {`${en_name}(${entity_name})`}
            </Text>
          </Billboard>
        </Suspense>
      </group>

      {children.map(entity => {
        const isCurrentChildSelected = selectedEntity?.entity?.id === entity.id;
        const childOpacity = !hasSelection
          ? 1
          : isCurrentZoneSelected || isCurrentChildSelected
            ? 1
            : 0;

        if (entity.en_name === "Rack") {
          return (
            <Rack
              key={entity.id}
              rack={entity}
              onBinClick={onBinClick}
              selectedBin={selectedBin}
              selectedRack={selectedRack}
              setSelectedRack={setSelectedRack}
              setLegendData={setLegendData}
              selectedEntity={selectedEntity}
              color={color}
              opacity={childOpacity}
            />
          )
        } else if (isStorageLocation(entity.en_name)) {
          return (
            <Bin
              key={entity.id}
              bin={entity}
              onBinClick={onBinClick}
              selectedBin={selectedBin}
              setLegendData={setLegendData}
              selectedEntity={selectedEntity}
              color={color}
              opacity={childOpacity}
              parentZoneId={zone.id}
              parentZoneName={entity_name}
            />
          )
        }
      })}
    </>
  );
};

export default Zone;
